import {
  FilterType,
  buildPastCoursesDatatableFilter,
  usePastCoursesDatatable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

export const startDateFilter = (source: ReturnType<typeof usePastCoursesDatatable>) => {
  return buildPastCoursesDatatableFilter(source, {
    identifier: 'startsOnFilter',
    title: i18n.t('performance_process.targets.see_past_courses.start_date_filter'),
    path: 'startsOn',
    type: FilterType.Date,
    categories: [
      {
        kind: 'DatePicker',
        operation: 'eq',
        value: dateToString(moment(), 'backend_datetime'),
      },
    ],
  })
}
